const get3DMapboxStyle = (is3D: boolean) => {
    if (!is3D) return undefined;
    return {
        version: 8,
        name: '3d',
        metadata: {id: '3d'},
        sources: {
            'raster-dem': {
                type: 'raster-dem',
                url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
                tileSize: 512,
                maxzoom: 14,
            },
        },
        layers: [
            {
                id: 'sky',
                type: 'sky',
                layout: {},
                paint: {
                    'sky-atmosphere-color': 'hsl(198, 83%, 69%)',
                    'sky-atmosphere-halo-color': 'hsl(176, 88%, 90%)',
                    'sky-gradient': [
                        'interpolate',
                        ['linear'],
                        ['sky-radial-progress'],
                        0.8,
                        'hsl(197, 83%, 47%)',
                        1,
                        'hsl(176, 72%, 91%)',
                    ],
                    'sky-atmosphere-sun-intensity': 15,
                },
            },
        ],
        terrain: {
            source: 'raster-dem',
            exaggeration: 1.3,
        },
        fog: {
            range: [-1, 20],
            color: '#ffffff',
            'horizon-blend': 0.1,
        },
    };
};

export default get3DMapboxStyle;
